export enum AdminMachinesRoutes {
  CalibrateAmpPosition = 'calibrate-amp-position',
  CalibrateVentionPosition = 'calibrate-vention-position',
  CheckFirmware = 'check-firmware',
  CreateForTeam = 'create-for-team',
  GetActiveModels = 'get-active-models',
  GetConfig = 'get-config',
  GetDetails = 'get-details',
  GetErrors = 'get-errors',
  GetLatestNetworkLog = 'get-latest-network-log',
  GetLogs = 'get-logs',
  GetMachineErrorWithType = 'get-machine-error-with-type',
  GetMachineErrorTypes = 'get-machine-error-types',
  GetMachines = 'get-machines',
  GetPitchPerformance = 'get-pitch-performance',
  GetRecentSessions = 'get-recent-sessions',
  GetRepeatabilityImages = 'get-repeatability-images',
  GetShotHistory = 'get-shot-history',
  PostCustomRequest = 'post-custom-request',
  ResetConnections = 'reset-connections',
  SideloadWebSocket = 'sideload-web-socket',
  UpdateConfig = 'update-config',
  UpdateMachine = 'update-machine',
  UpgradeFirmware = 'upgrade-firmware',
}
